import { render, staticRenderFns } from "./modal-edit-photo.vue?vue&type=template&id=391b32c9"
import script from "./modal-edit-photo.vue?vue&type=script&lang=js"
export * from "./modal-edit-photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports